const YOUTUBE_ID_REGEX =
  /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^/&]{10,12})/;

export const isYoutubeLink = url => Boolean(url?.includes('youtube') || url?.includes('youtu.be'));

// Null when no video id can be extracted (e.g. playlist links) — callers must
// handle it instead of assuming every YouTube URL is a playable video.
export const getYoutubeId = url => url?.match(YOUTUBE_ID_REGEX)?.[1] ?? null;

// Only these should render the in-app YouTube player; playlist/channel links
// have no video id and must fall back to opening in the browser.
export const isYoutubeVideoLink = url => isYoutubeLink(url) && getYoutubeId(url) !== null;
